import type { ScaleTime } from 'd3-scale';

import { EMPTY_DATAPOINT } from './tooltip/constants.js';
import {
  filterOutOfBounds,
  findClosestPoints,
  getClosestPoint,
} from './tooltip/find-closest-points.js';
import { filterTimestampsAndTimeframes } from './tooltip/timeseries-tooltip.js';
import { OVERLAY_PADDING } from '../../../../core/components/data-point/constants.js';
import type { Point } from '../../../../core/types/point.js';
import { getGroupedDataPointsByCoordinate } from '../../../../core/utils/group-by-threshold.js';
import type { YAxisScales } from '../../../types/state.js';
import type { DatapointsMap } from '../../../types/timeseries.js';
import type { TimeseriesDataPointAllTypes } from '../../displays/shared/types.js';

export const getPointsParsed = (
  mousePosition: Point | undefined,
  allDatapoints: TimeseriesDataPointAllTypes[],
  xScale: ScaleTime<number, number>,
  yScale: YAxisScales,
  datapointsMap: WeakMap<object, DatapointsMap>,
  width: number,
) => {
  const xPoints = mousePosition
    ? findClosestPoints(
        mousePosition.x,
        allDatapoints,
        xScale,
        yScale,
        datapointsMap,
      )
        .map((point) => ({
          ...point,
          x: point.x + OVERLAY_PADDING,
          y: point.y + OVERLAY_PADDING,
        }))
        .filter(filterOutOfBounds(width))
    : [];
  const closestPoint =
    xPoints.length > 0
      ? getClosestPoint(xPoints, mousePosition?.y)
      : EMPTY_DATAPOINT;

  const filteredPoints = filterTimestampsAndTimeframes(xPoints, closestPoint);
  const groupedPoints = getGroupedDataPointsByCoordinate(xPoints, 'y');

  return { closestPoint, filteredPoints, groupedPoints };
};
